import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

interface FiltersDrawerHeader {
  filterType?: string;
}
const FiltersDrawerHeader = ({ filterType }: FiltersDrawerHeader) => {
  const { t } = useTranslation('map');

  return <Container>{t(filterType!)}</Container>;
};

const Container = styled.div`
  font-size: 18px;
  font-family: materialSemiBold;
  color: #282828;
`;

export default FiltersDrawerHeader;
